import TagManager from 'react-gtm-module';

export interface TrackSignInEventProps {
  interactionLocation: string;
  linkText: string;
}

export const trackSignInEvent = ({
  interactionLocation,
  linkText,
}: TrackSignInEventProps) => {
  TagManager.dataLayer({
    dataLayer: {
      event: 'user_interaction',
      event_name: 'click_sign_in',
      interaction: {
        interaction_location: interactionLocation,
        link_text: linkText,
      },
    },
  });
};
